import { useMutation } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import { EDevice } from '@/constants';
import { postCmediaPurchase } from '@/modules/perseo-billing/services/api/billing/index';
import { billingMutationKeys } from '@/modules/perseo-billing/services/api/billing/mutations/billing-mutation-factory';

export const useCmediaPurchaseEvent = () => {
  const [searchParam] = useSearchParams();
  const platform = searchParam?.get('device') || EDevice.WEB;

  const { mutate } = useMutation(
    (payload: unknown) => postCmediaPurchase(payload, platform),
    {
      mutationKey: billingMutationKeys.createCmediaPurchase,
      onSuccess: (data) => {
        console.log('Cmedia Purchase Event Success:', data);
      },
      onError: (error) => {
        console.error('Cmedia Purchase Event Error:', error);
      }
    }
  );

  return {
    mutate
  };
};
